const SAFE_DOM_PROP_NAMES = new Set(['id', 'className', 'title']);

const getPreviewDomProps = (props) => Object.fromEntries(
  Object.entries(props).filter(([key]) => (
    SAFE_DOM_PROP_NAMES.has(key)
    || key.startsWith('data-')
    || key.startsWith('aria-')
  )),
);

export default getPreviewDomProps;
